import { Injectable } from '@angular/core';
import { PermsModel } from './../models/index';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private localStorageS;

  constructor() {this.localStorageS = localStorage }

  setStorage(name: string, obj: any): void{
    this.localStorageS.setItem(name, JSON.stringify(obj));
  }

  deleteStorage(name: string): void{
    this.localStorageS.removeItem(name);
  }

  getStorage(name: string): any{
    return this.localStorageS.getItem(name);
  }

  getToken(){
    return JSON.parse(this.localStorageS.getItem('access_token'));
  }  

  setPerms(permsList: PermsModel[]) {
    let perms: string[] = [];
    permsList.forEach(element => {
      perms.push(element.PermName);
    });
    this.localStorageS.setItem('perms', JSON.stringify(perms));
  }

  getPerms() {
    return JSON.parse(this.localStorageS.getItem('perms'));
  }

  removPerms(): void {
    this.localStorageS.removeItem('perms');
  }
}

